__turbopack_context__.v({
  "parent": "AdditionalInfoMobile-module-scss-module__p2vnaG__parent",
});
